import barackObamaPNG from '~/assets/images/communication/barack-obama.png'
import billGatesPNG from '~/assets/images/communication/bill-gates.png'
import breneBrownPNG from '~/assets/images/communication/brene-brown.png'
import michelleObamaPNG from '~/assets/images/communication/michelle-obama.png'
import morganFreemanPNG from '~/assets/images/communication/morgan-freeman.png'
import oprahWinfreyPNG from '~/assets/images/communication/oprah-winfrey.png'
import serenaWilliamsPNG from '~/assets/images/communication/serena-williams.png'
import steveJobsPNG from '~/assets/images/communication/steve-jobs.png'
import tonyRobbinsPNG from '~/assets/images/communication/tony-robbins.png'

export const ROLE_MODEL_QUESTION = 'When someone interrupts you, you usually...'

export const ROLE_MODELS = [
  { key: 'barackObama', name: 'Barack Obama', image: barackObamaPNG },
  { key: 'breneBrown', name: 'Brené Brown', image: breneBrownPNG },
  { key: 'steveJobs', name: 'Steve Jobs', image: steveJobsPNG },
  { key: 'tonyRobbins', name: 'Tony Robbins', image: tonyRobbinsPNG },
  { key: 'michelleObama', name: 'Michelle Obama', image: michelleObamaPNG },
  { key: 'serenaWilliams', name: 'Serena Williams', image: serenaWilliamsPNG },
  { key: 'morganFreeman', name: 'Morgan Freeman', image: morganFreemanPNG },
  { key: 'billGates', name: 'Bill Gates', image: billGatesPNG },
  { key: 'oprahWinfrey', name: 'Oprah Winfrey', image: oprahWinfreyPNG },
] as const
